import { PARAGRAPH_STYLES as m } from "../../constants/default-styles.mjs";
const t = (r = !1) => ({
  ...m,
  ...r ? { marginTop: "1rem", marginBottom: "1rem" } : { marginTop: "0", marginBottom: "0" }
});
export {
  t as getParagraphStyles
};
